import React, { Component } from 'react'

import LogoHeader from './components/LogoHeader'
import TitleSection from './components/TitleSection'
import DownloadSection from './components/DownloadSection'
import OverviewSection from './components/OverviewSection'
import FeaturesSection from './components/FeaturesSection'

class App extends Component {
  render() {
    return (
      <div>
        <LogoHeader />
        <TitleSection />
        <OverviewSection />
        <FeaturesSection />
        <span id="download">
          <div className="mt3 mb3">
            <DownloadSection />
          </div>
        </span>
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js